import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TitleStrategy, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {

    private readonly DEFAULT_TITLE = 'SLS PDI DEALER';
    private readonly PREFIX = 'DEALER -';

    constructor(private title: Title) {
        super();
    }

    override updateTitle(routerState: RouterStateSnapshot): void {
        const routeTitle = this.buildTitle(routerState);

        if (routeTitle) {
            this.title.setTitle(`${this.PREFIX}${routeTitle}`);
        } else {
            this.title.setTitle(this.DEFAULT_TITLE);
        }
    }

}